<template>
    <v-col
        :cols="width"
    >
        <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            offset-y
            max-width="290px"
            min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    id="questionnaire_date_picker"
                    :disabled="readonly"
                    :readonly="item.props.readonly"
                    :label="item.props.label || 'Date'"
                    :name="item.name"
                    :rules="rules"
                    :value="formattedDate"
                    hint="Date must be selected, not typed"
                    outlined
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    ref="input"
                    v-on:blur="modelData = parseDate($event.target.value)"
                    v-on="on"
                >
                    <template v-if="item.props.tooltip" v-slot:append-outer>
                        <v-tooltip
                            top
                            max-width="620"
                        >
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on">mdi-information</v-icon>
                            </template>
                            <div v-html="item.props.tooltip"></div>
                        </v-tooltip>
                    </template>
                </v-text-field>
            </template>

            <v-date-picker
                :disabled="readonly"
                :min="item.props.minimumDate ? getMinimumDate() : ''"
                :max="item.props.maximumDate ? getMaximumDate() : ''"
                :allowed-dates="item.props.firstOfMonthOnly ? allowFirstDayOnly : null"
                no-title
                v-model="modelData"
                v-on:input="menu1 = false"
            />
        </v-menu>
    </v-col>
</template>
<script>
    import {DEFAULT_INPUT_WIDTH} from '../constants';

    export default {
        name: 'DatePicker',
        props: ['item', 'value', 'readonly', 'rules', 'width'],
        data: function () {
            return {
                menu1: false,
                DEFAULT_INPUT_WIDTH
            };
        },
        methods: {
            getMinimumDate () {
                const { props } = this.item;
                const { minimumDate } = props;

                if ( minimumDate.indexOf('-') != -1) {
                    const type = minimumDate.split('-')[0]
                    const days = minimumDate.split('-')[1]
                
                    switch (type) {
                        // "business-7" - 7 business days : number can change
                        case 'business': {
                            return this.addBusinessDays(days);
                        }
                        // "calendar-7" - 7 calendar day : number can change
                        case 'calendar': {
                            return this.addCalendarDays(days);
                        }
                    }
                }else {
                    // "today" - nothing from today backwards
                    const now = new Date();
                    const year = String(now.getFullYear()).padStart(4, '0');
                    const month = String(now.getMonth() + 1).padStart(2, '0');
                    const date = String(now.getDate()).padStart(2, '0');

                    return `${year}-${month}-${date}`;
                }
            },

            getMaximumDate () {
                const { props } = this.item;
                const { maximumDate } = props;

                if ( maximumDate.indexOf('-') != -1) {
                    const type = maximumDate.split('-')[0]
                    const days = maximumDate.split('-')[1]
                
                    switch (type) {
                        // "business-7" - 7 business days : number can change
                        case 'business': {
                            return this.addBusinessDays(days);
                        }
                        // "calendar-7" - 7 calendar day : number can change
                        case 'calendar': {
                            return this.addCalendarDays(days);
                        }
                    }
                } else {
                    // "today" - nothing from today backwards
                    const now = new Date();
                    const year = String(now.getFullYear()).padStart(4, '0');
                    const month = String(now.getMonth() + 1).padStart(2, '0');
                    const date = String(now.getDate()).padStart(2, '0');

                    return `${year}-${month}-${date}`;
                }
            },

            allowFirstDayOnly(date) {
                // Allow only the first day of each month
                const day = new Date(date+'T00:00:00').getDate();
                return day === 1;
            },

            addBusinessDays: function (daysToAdd) {
                const currentDate = new Date();

                for (let i = 1; i <= daysToAdd; i++) {
                    currentDate.setDate(currentDate.getDate() + 1);
                    if (currentDate.getDay() === 6) {
                        currentDate.setDate(currentDate.getDate() + 2);
                    } else if (currentDate.getDay() === 0) {
                        currentDate.setDate(currentDate.getDate() + 1);
                    }
                }
                
                const calcDate = currentDate.toISOString().substring(0,10)
                return calcDate
            },

            addCalendarDays: function (daysToAdd) {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() + daysToAdd);
                
                const calcDate = currentDate.toISOString().substring(0,10)
                return calcDate
            },

            formatDate (date) {
                if (!date) {
                    return null;
                }

                const [year, month, day] = date.split('-');

                return `${month}/${day}/${year}`;
            },

            parseDate (date) {
                if (!date) {
                    return null;
                }

                const [month, day, year] = date.split('/');
                
                if (month && day && year) {
                    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                }
            },
            
            validate: function (newVal) {
                // We are going to roll our own validate method for the datepicker
                // Why you ask?
                // First - The datepicker element doesn't have a validate method, previously we would validate the text field which displays the value
                // Second - The text field doesn't get updated until the value is set, which is after validation.
                // This is basically the same logic used by Vuetify for validation.

                const self = this;
                const errorBucket = [];

                if (this.rules && this.rules.length) {
                    this.rules.forEach((thisRule) => {
                        const isValid = thisRule(newVal);

                        if (isValid === false || typeof isValid === 'string') {
                            errorBucket.push(isValid || '');
                        }
                    });
                }

                return errorBucket.length === 0;
            }
        },
        computed: {
            formattedDate: {
                get: function () {
                    return this.formatDate(this.modelData);
                },
                set: function (newVal) {
                    const parsedDate = this.parseDate(newVal);

                    if (parsedDate) {
                        this.$emit('input', parsedDate);
                    }
                }
            },
            modelData: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                }
            }
        },
        mounted () {
            // console.log(this.item, this.readonly)
            document.getElementById('questionnaire_date_picker').addEventListener('keypress', (e) => {
                e.preventDefault();
                // NEED SOME KIND OF WARNING HERE THAT SAYS YOU CAN'T TYPE IN A DATE
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/questionnaire_template/date-picker.vue